<!-- =========================================================
     Start Short Course List
========================================================= -->

<div class="ecb-web-public-page" *ngIf="isMainComponent">

    <!-- Start Short Courses List Banner Section -->
    <section class="ecb-web-short-courses-list-banner-section">

        <!-- Start Short Courses List Banner Overlay -->
        <div class="ecb-web-short-courses-list-banner-overlay"></div>
        <!-- End Short Courses List Banner Overlay -->

        <div class="container ecb-web-short-courses-list-banner-container">

            <div class="row align-items-center">

                <!-- Start Short Courses List Banner Content -->
                <div class="col-12 col-lg-12">

                    <!-- =====================================================
                         Heading
                    ====================================================== -->

                    <div class="ecb-x-course-list-heading-2"
                        *ngIf="courseType !== 'ALL' || activeAllCoursesSection === 'POPULAR'">


                        <!-- all short courses Courses Title -->
                        <ng-container *ngIf="courseType === 'ALL_SHORT_COURSES'">

                            <div class="row  ">
                                <!-- LEFT CONTENT -->
                                <div class="col-12 col-lg-5">

                                    <div class="ecb-web-hsr-banner-content">

                                        <span class="ecb-web-hsr-banner-label">

                                        </span>
                                        <span class="pill">ECB Training</span>

                                        <h1>
                                            Short Courses
                                        </h1>

                                        <div class="ecb-web-short-title-line"></div>

                                        <p>
                                            Explore our available nationally recognised short courses.
                                            Select a course to view full details, requirements, brochure
                                            information and enquiry options.
                                        </p>

                                    </div>



                                </div>


                                <!-- RIGHT FILTER -->
                                <div class="col-12 col-lg-7">

                                    <div class="ecb-web-long-course-search">
                                        <!-- Start State Selection -->
                                        <div class="ecb-states-select-wrapper">

                                            <label class="ecb-states-select-label">Location</label>

                                            <p-selectButton [options]="statesList"
                                                [(ngModel)]="selectedShortCourseStateCode" optionLabel="siteName"
                                                optionValue="code" [multiple]="false" [allowEmpty]="false"
                                                (onChange)="onShortCourseStateChange($event.value)"
                                                styleClass="ecb-states-select-button">
                                            </p-selectButton>

                                        </div>
                                        <!-- End State Selection -->

                                        <div class="ecb-web-long-course-search-field">

                                            <label>
                                                All Courses

                                            </label>
                                            <p-dropdown [options]="shortCourseOptions"
                                                [(ngModel)]="selectedCourseFilter" optionLabel="courseTitle"
                                                optionValue="courseTitle" [filter]="false"
                                                [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                                [loading]="dropdownLoading" appendTo="body"
                                                panelStyleClass="ecb-short-course-dropdown-panel"
                                                placeholder="Select a course" (onShow)="onCourseDropdownOpened()"
                                                (onHide)="onCourseDropdownClosed()">

                                                <!-- Server-side search -->
                                                <ng-template pTemplate="header">
                                                    <div class="p-2">
                                                        <input type="search" class="form-control"
                                                            placeholder="Search course code or title"
                                                            [value]="dropdownSearchText"
                                                            (input)="onDropdownSearch($any($event.target).value)">
                                                    </div>
                                                </ng-template>

                                                <!-- Selected course -->
                                                <ng-template pTemplate="selectedItem" let-item>
                                                    <span *ngIf="item">
                                                        {{ item.courseCode }} - {{ item.courseTitle }}
                                                    </span>
                                                </ng-template>

                                                <!-- Dropdown options -->
                                                <ng-template pTemplate="item" let-item>
                                                    <div class="ecb-web-course-option">
                                                        <strong>{{ item.courseCode }}</strong>
                                                        <span>{{ item.courseTitle }}</span>
                                                    </div>
                                                </ng-template>

                                                <!-- Load additional courses -->
                                                <ng-template pTemplate="footer">
                                                    <div class="p-2 text-center" *ngIf="
                dropdownHasLoaded &&
                shortCourseOptions.length < dropdownTotalRecords
            ">

                                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                                            [disabled]="dropdownLoading"
                                                            (click)="onCourseDropdownScroll()">

                                                            {{
                                                            dropdownLoading
                                                            ? 'Loading...'
                                                            : 'Load more courses'
                                                            }}

                                                        </button>

                                                    </div>
                                                </ng-template>

                                            </p-dropdown>

                                            <!--  <p-dropdown [options]="shortCourseOptions"
                                                [(ngModel)]="selectedCourseFilter" optionValue="courseTitle"
                                                [filter]="true" filterBy="courseCode,courseTitle,qualificationType"
                                                [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                                appendTo="body" placeholder="Select a course">

                                                <ng-template pTemplate="selectedItem" let-item>
                                                    <span *ngIf="item">
                                                        {{ item.courseCode }} - {{ item.courseTitle }}
                                                    </span>
                                                </ng-template>

                                                <ng-template pTemplate="item" let-item>
                                                    <div class="ecb-web-course-option">
                                                        <strong>{{ item.courseCode }}</strong>
                                                        <span>{{ item.courseTitle }}</span>
                                                    </div>
                                                </ng-template>

                                            </p-dropdown> -->

                                        </div>


                                        <div class="ecb-web-long-course-search-field">

                                            <label for="homeLongCourseKeyword">
                                                Keyword
                                            </label>

                                            <div class="ecb-web-long-course-keyword">

                                                <i class="bi bi-search"></i>

                                                <input id="homeLongCourseKeyword" type="search"
                                                    [(ngModel)]="searchKeyword" placeholder="Search Course">

                                            </div>

                                        </div>


                                        <button type="button" class="btn ecb-web-long-course-search-button"
                                            (click)="searchShortCourses()">

                                            <i class="bi bi-search"></i>
                                            Search

                                        </button>

                                    </div>

                                </div>

                            </div>

                        </ng-container>


                        <!-- all short courses Courses Title -->
                        <ng-container *ngIf="courseType === 'ALL_COURSES'">

                            <div class="row  ">
                                <!-- LEFT CONTENT -->
                                <div class="col-12 col-lg-5">

                                    <div class="ecb-web-hsr-banner-content">

                                        <span class="ecb-web-hsr-banner-label">

                                        </span>
                                        <span class="pill">ECB Training</span>

                                        <h1>
                                            All Courses
                                        </h1>

                                        <div class="ecb-web-short-title-line"></div>

                                        <p>
                                            Explore our available nationally recognised all courses.
                                            Select a course to view full details, requirements, brochure
                                            information and enquiry options.
                                        </p>

                                    </div>



                                </div>


                                <!-- RIGHT FILTER -->
                                <div class="col-12 col-lg-7">

                                    <div class="ecb-web-long-course-search">
                                        <!-- Start State Selection -->
                                        <div class="ecb-states-select-wrapper">

                                            <label class="ecb-states-select-label">Location</label>

                                            <p-selectButton [options]="statesList"
                                                [(ngModel)]="selectedShortCourseStateCode" optionLabel="siteName"
                                                optionValue="code" [multiple]="false" [allowEmpty]="false"
                                                (onChange)="onShortCourseStateChange($event.value)"
                                                styleClass="ecb-states-select-button">
                                            </p-selectButton>

                                        </div>
                                        <!-- End State Selection -->

                                        <div class="ecb-web-long-course-search-field">

                                            <label>
                                                All Courses
                                            </label>
                                            <p-dropdown [options]="shortCourseOptions"
                                                [(ngModel)]="selectedCourseFilter" optionLabel="courseTitle"
                                                optionValue="courseTitle" [filter]="false"
                                                [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                                [loading]="dropdownLoading" appendTo="body"
                                                panelStyleClass="ecb-short-course-dropdown-panel"
                                                placeholder="Select a course" (onShow)="onCourseDropdownOpened()"
                                                (onHide)="onCourseDropdownClosed()">

                                                <!-- Server-side search -->
                                                <ng-template pTemplate="header">
                                                    <div class="p-2">
                                                        <input type="search" class="form-control"
                                                            placeholder="Search course code or title"
                                                            [value]="dropdownSearchText"
                                                            (input)="onDropdownSearch($any($event.target).value)">
                                                    </div>
                                                </ng-template>

                                                <!-- Selected course -->
                                                <ng-template pTemplate="selectedItem" let-item>
                                                    <span *ngIf="item">
                                                        {{ item.courseCode }} - {{ item.courseTitle }}
                                                    </span>
                                                </ng-template>

                                                <!-- Dropdown options -->
                                                <ng-template pTemplate="item" let-item>
                                                    <div class="ecb-web-course-option">
                                                        <strong>{{ item.courseCode }}</strong>
                                                        <span>{{ item.courseTitle }}</span>
                                                    </div>
                                                </ng-template>

                                                <!-- Load additional courses -->
                                                <ng-template pTemplate="footer">
                                                    <div class="p-2 text-center" *ngIf="
                dropdownHasLoaded &&
                shortCourseOptions.length < dropdownTotalRecords
            ">

                                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                                            [disabled]="dropdownLoading"
                                                            (click)="onCourseDropdownScroll()">

                                                            {{
                                                            dropdownLoading
                                                            ? 'Loading...'
                                                            : 'Load more courses'
                                                            }}

                                                        </button>

                                                    </div>
                                                </ng-template>

                                            </p-dropdown>

                                            <!--       <p-dropdown [options]="shortCourseOptions"
                                                [(ngModel)]="selectedCourseFilter" optionValue="courseTitle"
                                                [filter]="true" filterBy="courseCode,courseTitle,qualificationType"
                                                [virtualScroll]="true" [showClear]="!!selectedCourseFilter"
                                                [virtualScrollItemSize]="42" appendTo="body"
                                                placeholder="Select a course">

                                                <ng-template pTemplate="selectedItem" let-item>
                                                    <span *ngIf="item">
                                                        {{ item.courseCode }} - {{ item.courseTitle }}
                                                    </span>
                                                </ng-template>

                                                <ng-template pTemplate="item" let-item>

                                                    <div class="ecb-web-course-option">

                                                        <strong>
                                                            {{ item.courseCode }}
                                                        </strong>

                                                        <span>
                                                            {{ item.courseTitle }}
                                                        </span>

                                                    </div>

                                                </ng-template>

                                            </p-dropdown> -->

                                        </div>


                                        <div class="ecb-web-long-course-search-field">

                                            <label for="homeLongCourseKeyword">
                                                Keyword
                                            </label>

                                            <div class="ecb-web-long-course-keyword">

                                                <i class="bi bi-search"></i>

                                                <input id="homeLongCourseKeyword" type="search"
                                                    [(ngModel)]="searchKeyword" placeholder="Search Course">

                                            </div>

                                        </div>


                                        <button type="button" class="btn ecb-web-long-course-search-button"
                                            (click)="searchShortCourses()">

                                            <i class="bi bi-search"></i>
                                            Search

                                        </button>

                                    </div>

                                </div>

                            </div>

                        </ng-container>

                        <!-- VOC Title -->
                        <ng-container *ngIf="courseType === 'VOC'">
                            <div class="ecb-web-hsr-banner-content">

                                <span class="ecb-web-hsr-banner-label">

                                </span>
                                <span class="pill">ECB Training</span>

                                <h1>
                                    Verification of Competency
                                </h1>
                                <div class="ecb-web-short-title-line"></div>
                                <p>
                                    Browse our Verification of Competency assessments.
                                    Select an assessment to view detailed information,<br>
                                    required documents and enquiry options.
                                </p>


                            </div>

                        </ng-container>

                        <!-- Other Title -->
                        <ng-container *ngIf="courseType === 'SS'">
                            <div class="ecb-web-hsr-banner-content">

                                <span class="ecb-web-hsr-banner-label">

                                </span>
                                <span class="pill">ECB Training</span>

                                <h1>
                                    Skill Sets
                                </h1>
                                <div class="ecb-web-short-title-line"></div>
                                <p>
                                    Browse our Skill Sets.
                                    Select an assessment to view detailed information,<br>
                                    required documents and enquiry options.
                                </p>


                            </div>
                        </ng-container>

                        <!-- HRC Title -->
                        <ng-container *ngIf="courseType === 'HRC'">
                            <div class="ecb-web-hsr-banner-content">

                                <span class="ecb-web-hsr-banner-label">

                                </span>
                                <span class="pill">ECB Training</span>

                                <h1>
                                    High Risk Courses
                                </h1>
                                <div class="ecb-web-short-title-line"></div>
                                <p>
                                    Browse our High Risk Courses.
                                    Select an assessment to view detailed information,<br>
                                    required documents and enquiry options.
                                </p>


                            </div>


                        </ng-container>



                    </div>


                </div>

            </div>

        </div>

    </section>
    <!-- End Short Courses List Banner Section -->

</div>


<section class="ecb-x-course-list-section" id="short-course-list">


    <div class="container">


        <!-- =====================================================
          Start Popular / Other Courses Tabs
        ====================================================== -->

        <div class="ecb-x-course-section-tabs" *ngIf="courseType === 'ALL'">

            <button type="button" class="ecb-x-course-section-tab"
                [class.active]="activeAllCoursesSection === 'POPULAR'" (click)="selectAllCoursesSection('POPULAR')">

                <i class="bi bi-stars"></i>
                <span>Popular Courses</span>

            </button>

            <button type="button" class="ecb-x-course-section-tab" [class.active]="activeAllCoursesSection === 'OTHER'"
                (click)="selectAllCoursesSection('OTHER')">

                <i class="bi bi-chat-square-text"></i>
                <span>Other Courses</span>

            </button>

        </div>
        <!-- =====================================================
          End Popular / Other Courses Tabs
        ====================================================== -->


        <!-- =====================================================
             Heading
        ====================================================== -->

        <div class="ecb-x-course-list-heading"
            *ngIf="!isMainComponent && (courseType !== 'ALL' || activeAllCoursesSection === 'POPULAR')">

            <!--     <span class="ecb-x-course-eyebrow">
                ECB TRAINING
            </span> -->
            <!-- Popular Courses Title -->
            <ng-container *ngIf="courseType === 'ALL'">


                <div class="row align-items-center ecb-web-uoc-header">

                    <!-- LEFT CONTENT -->
                    <div class="col-12 col-lg-5">

                        <div class="ecb-web-uoc-heading">

                            <span class="ecb-web-uoc-eyebrow">
                                ECB TRAINING
                            </span>

                            <h1>
                                Popular Courses
                            </h1>

                            <p>
                                Explore our popular training courses. Select a course to view full
                                details, requirements, brochure information and enquiry options.
                            </p>

                        </div>

                    </div>


                    <!-- RIGHT FILTER -->
                    <div class="col-12 col-lg-7">

                        <div class="ecb-web-long-course-search">

                            <div class="ecb-web-long-course-search-field">

                                <label>
                                    All Courses
                                </label>
                                <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionLabel="courseTitle" optionValue="courseTitle" [filter]="false"
                                    [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                    [loading]="dropdownLoading" appendTo="body"
                                    panelStyleClass="ecb-short-course-dropdown-panel" placeholder="Select a course"
                                    (onShow)="onCourseDropdownOpened()" (onHide)="onCourseDropdownClosed()">

                                    <!-- Server-side search -->
                                    <ng-template pTemplate="header">
                                        <div class="p-2">
                                            <input type="search" class="form-control"
                                                placeholder="Search course code or title" [value]="dropdownSearchText"
                                                (input)="onDropdownSearch($any($event.target).value)">
                                        </div>
                                    </ng-template>

                                    <!-- Selected course -->
                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <!-- Dropdown options -->
                                    <ng-template pTemplate="item" let-item>
                                        <div class="ecb-web-course-option">
                                            <strong>{{ item.courseCode }}</strong>
                                            <span>{{ item.courseTitle }}</span>
                                        </div>
                                    </ng-template>

                                    <!-- Load additional courses -->
                                    <ng-template pTemplate="footer">
                                        <div class="p-2 text-center" *ngIf="
                dropdownHasLoaded &&
                shortCourseOptions.length < dropdownTotalRecords
            ">

                                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                                [disabled]="dropdownLoading" (click)="onCourseDropdownScroll()">

                                                {{
                                                dropdownLoading
                                                ? 'Loading...'
                                                : 'Load more courses'
                                                }}

                                            </button>

                                        </div>
                                    </ng-template>

                                </p-dropdown>

                                <!--    <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionValue="courseTitle" [filter]="true"
                                    filterBy="courseCode,courseTitle,qualificationType"
                                    [showClear]="!!selectedCourseFilter" [virtualScroll]="true"
                                    [virtualScrollItemSize]="42" appendTo="body" placeholder="Select a course">

                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <ng-template pTemplate="item" let-item>
                                        <div class="ecb-web-course-option">

                                            <strong>
                                                {{ item.courseCode }}
                                            </strong>

                                            <span>
                                                {{ item.courseTitle }}
                                            </span>

                                        </div>
                                    </ng-template>

                                </p-dropdown> -->

                            </div>


                            <div class="ecb-web-long-course-search-field">

                                <label for="homeLongCourseKeyword">
                                    Keyword
                                </label>

                                <div class="ecb-web-long-course-keyword">

                                    <i class="bi bi-search"></i>

                                    <input id="homeLongCourseKeyword" type="search" [(ngModel)]="searchKeyword"
                                        placeholder="Search Short Course" (keyup.enter)="searchShortCourses()">

                                </div>

                            </div>


                            <button type="button" class="btn ecb-web-long-course-search-button"
                                (click)="searchShortCourses()">

                                <i class="bi bi-search"></i>
                                Search

                            </button>

                        </div>

                    </div>

                </div>

            </ng-container>

            <!-- ALL Courses  Title -->
            <ng-container *ngIf="courseType === 'ALL_COURSES'">


                <div class="row align-items-center ecb-web-uoc-header">

                    <!-- LEFT CONTENT -->
                    <div class="col-12 col-lg-5">

                        <div class="ecb-web-uoc-heading">

                            <span class="ecb-web-uoc-eyebrow">
                                ECB TRAINING
                            </span>

                            <h1>
                                All Courses
                            </h1>

                            <p>
                                Explore our available all courses.
                                Select a course to view full details, requirements, brochure
                                information and enquiry options.
                            </p>

                        </div>

                    </div>


                    <!-- RIGHT FILTER -->
                    <div class="col-12 col-lg-7">

                        <div class="ecb-web-long-course-search">

                            <div class="ecb-web-long-course-search-field">

                                <label>
                                    All Courses
                                </label>
                                <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionLabel="courseTitle" optionValue="courseTitle" [filter]="false"
                                    [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                    [loading]="dropdownLoading" appendTo="body"
                                    panelStyleClass="ecb-short-course-dropdown-panel" placeholder="Select a course"
                                    (onShow)="onCourseDropdownOpened()" (onHide)="onCourseDropdownClosed()">

                                    <!-- Server-side search -->
                                    <ng-template pTemplate="header">
                                        <div class="p-2">
                                            <input type="search" class="form-control"
                                                placeholder="Search course code or title" [value]="dropdownSearchText"
                                                (input)="onDropdownSearch($any($event.target).value)">
                                        </div>
                                    </ng-template>

                                    <!-- Selected course -->
                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <!-- Dropdown options -->
                                    <ng-template pTemplate="item" let-item>
                                        <div class="ecb-web-course-option">
                                            <strong>{{ item.courseCode }}</strong>
                                            <span>{{ item.courseTitle }}</span>
                                        </div>
                                    </ng-template>

                                    <!-- Load additional courses -->
                                    <ng-template pTemplate="footer">
                                        <div class="p-2 text-center" *ngIf="
                dropdownHasLoaded &&
                shortCourseOptions.length < dropdownTotalRecords
            ">

                                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                                [disabled]="dropdownLoading" (click)="onCourseDropdownScroll()">

                                                {{
                                                dropdownLoading
                                                ? 'Loading...'
                                                : 'Load more courses'
                                                }}

                                            </button>

                                        </div>
                                    </ng-template>

                                </p-dropdown>

                                <!--     <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionValue="courseTitle" [filter]="true"
                                    filterBy="courseCode,courseTitle,qualificationType"
                                    [showClear]="!!selectedCourseFilter" [virtualScroll]="true"
                                    [virtualScrollItemSize]="42" appendTo="body" placeholder="Select a course">

                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <ng-template pTemplate="item" let-item>
                                        <div class="ecb-web-course-option">

                                            <strong>
                                                {{ item.courseCode }}
                                            </strong>

                                            <span>
                                                {{ item.courseTitle }}
                                            </span>

                                        </div>
                                    </ng-template>

                                </p-dropdown> -->

                            </div>


                            <div class="ecb-web-long-course-search-field">

                                <label for="homeLongCourseKeyword">
                                    Keyword
                                </label>

                                <div class="ecb-web-long-course-keyword">

                                    <i class="bi bi-search"></i>

                                    <input id="homeLongCourseKeyword" type="search" [(ngModel)]="searchKeyword"
                                        placeholder="Search Short Course" (keyup.enter)="searchShortCourses()">

                                </div>

                            </div>


                            <button type="button" class="btn ecb-web-long-course-search-button"
                                (click)="searchShortCourses()">

                                <i class="bi bi-search"></i>
                                Search

                            </button>

                        </div>

                    </div>

                </div>

            </ng-container>

            <!-- all short courses Courses Title -->
            <ng-container *ngIf="courseType === 'ALL_SHORT_COURSES'">

                <div class="row align-items-center ecb-web-uoc-header">

                    <!-- LEFT CONTENT -->
                    <div class="col-12 col-lg-5">

                        <div class="ecb-web-uoc-heading">

                            <span class="ecb-web-uoc-eyebrow">
                                ECB TRAINING
                            </span>

                            <h1>
                                Short Courses
                            </h1>

                            <p>
                                Explore our available nationally recognised short courses.
                                Select a course to view full details, requirements, brochure
                                information and enquiry options.
                            </p>

                        </div>

                    </div>


                    <!-- RIGHT FILTER -->
                    <div class="col-12 col-lg-7">

                        <div class="ecb-web-long-course-search">

                            <div class="ecb-web-long-course-search-field">

                                <label>
                                    All Courses
                                </label>
                                <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionLabel="courseTitle" optionValue="courseTitle" [filter]="false"
                                    [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                    [loading]="dropdownLoading" appendTo="body"
                                    panelStyleClass="ecb-short-course-dropdown-panel" placeholder="Select a course"
                                    (onShow)="onCourseDropdownOpened()" (onHide)="onCourseDropdownClosed()">

                                    <!-- Server-side search -->
                                    <ng-template pTemplate="header">
                                        <div class="p-2">
                                            <input type="search" class="form-control"
                                                placeholder="Search course code or title" [value]="dropdownSearchText"
                                                (input)="onDropdownSearch($any($event.target).value)">
                                        </div>
                                    </ng-template>

                                    <!-- Selected course -->
                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <!-- Dropdown options -->
                                    <ng-template pTemplate="item" let-item>
                                        <div class="ecb-web-course-option">
                                            <strong>{{ item.courseCode }}</strong>
                                            <span>{{ item.courseTitle }}</span>
                                        </div>
                                    </ng-template>

                                    <!-- Load additional courses -->
                                    <ng-template pTemplate="footer">
                                        <div class="p-2 text-center" *ngIf="
                dropdownHasLoaded &&
                shortCourseOptions.length < dropdownTotalRecords
            ">

                                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                                [disabled]="dropdownLoading" (click)="onCourseDropdownScroll()">

                                                {{
                                                dropdownLoading
                                                ? 'Loading...'
                                                : 'Load more courses'
                                                }}

                                            </button>

                                        </div>
                                    </ng-template>

                                </p-dropdown>

                                <!--   <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionValue="courseTitle" [filter]="true"
                                    filterBy="courseCode,courseTitle,qualificationType" [virtualScroll]="true"
                                    [showClear]="!!selectedCourseFilter" [virtualScrollItemSize]="42" appendTo="body"
                                    placeholder="Select a course">

                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <ng-template pTemplate="item" let-item>

                                        <div class="ecb-web-course-option">

                                            <strong>
                                                {{ item.courseCode }}
                                            </strong>

                                            <span>
                                                {{ item.courseTitle }}
                                            </span>

                                        </div>

                                    </ng-template>

                                </p-dropdown> -->

                            </div>


                            <div class="ecb-web-long-course-search-field">

                                <label for="homeLongCourseKeyword">
                                    Keyword
                                </label>

                                <div class="ecb-web-long-course-keyword">

                                    <i class="bi bi-search"></i>

                                    <input id="homeLongCourseKeyword" type="search" [(ngModel)]="searchKeyword"
                                        placeholder="Search Course">

                                </div>

                            </div>


                            <button type="button" class="btn ecb-web-long-course-search-button"
                                (click)="searchShortCourses()">

                                <i class="bi bi-search"></i>
                                Search

                            </button>

                        </div>

                    </div>

                </div>

            </ng-container>

            <!-- Uoc Courses Title -->
            <ng-container *ngIf="courseType === 'UOC'">

                <div class="row align-items-center ecb-web-uoc-header">

                    <!-- LEFT CONTENT -->
                    <div class="col-12 col-lg-5">

                        <div class="ecb-web-uoc-heading">

                            <span class="ecb-web-uoc-eyebrow">
                                ECB TRAINING
                            </span>

                            <h1>
                                Units of Competency
                            </h1>

                            <p>
                                Explore our available nationally recognised units of competency.
                                Select a course to view full details, requirements, brochure
                                information and enquiry options.
                            </p>

                        </div>

                    </div>


                    <!-- RIGHT FILTER -->
                    <div class="col-12 col-lg-7">

                        <div class="ecb-web-long-course-search">

                            <div class="ecb-web-long-course-search-field">

                                <label>
                                    All Courses
                                </label>
                                <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionLabel="courseTitle" optionValue="courseTitle" [filter]="false"
                                    [showClear]="!!selectedCourseFilter" [scrollHeight]="'300px'"
                                    [loading]="dropdownLoading" appendTo="body"
                                    panelStyleClass="ecb-short-course-dropdown-panel" placeholder="Select a course"
                                    (onShow)="onCourseDropdownOpened()" (onHide)="onCourseDropdownClosed()">

                                    <!-- Server-side search -->
                                    <ng-template pTemplate="header">
                                        <div class="p-2">
                                            <input type="search" class="form-control"
                                                placeholder="Search course code or title" [value]="dropdownSearchText"
                                                (input)="onDropdownSearch($any($event.target).value)">
                                        </div>
                                    </ng-template>

                                    <!-- Selected course -->
                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <!-- Dropdown options -->
                                    <ng-template pTemplate="item" let-item>
                                        <div class="ecb-web-course-option">
                                            <strong>{{ item.courseCode }}</strong>
                                            <span>{{ item.courseTitle }}</span>
                                        </div>
                                    </ng-template>

                                    <!-- Load additional courses -->
                                    <ng-template pTemplate="footer">
                                        <div class="p-2 text-center" *ngIf="
                dropdownHasLoaded &&
                shortCourseOptions.length < dropdownTotalRecords
            ">

                                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                                [disabled]="dropdownLoading" (click)="onCourseDropdownScroll()">

                                                {{
                                                dropdownLoading
                                                ? 'Loading...'
                                                : 'Load more courses'
                                                }}

                                            </button>

                                        </div>
                                    </ng-template>

                                </p-dropdown>

                                <!--      <p-dropdown [options]="shortCourseOptions" [(ngModel)]="selectedCourseFilter"
                                    optionValue="courseTitle" [filter]="true"
                                    filterBy="courseCode,courseTitle,qualificationType" [virtualScroll]="true"
                                    [showClear]="!!selectedCourseFilter" [virtualScrollItemSize]="42" appendTo="body"
                                    placeholder="Select a course">

                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span *ngIf="item">
                                            {{ item.courseCode }} - {{ item.courseTitle }}
                                        </span>
                                    </ng-template>

                                    <ng-template pTemplate="item" let-item>

                                        <div class="ecb-web-course-option">

                                            <strong>
                                                {{ item.courseCode }}
                                            </strong>

                                            <span>
                                                {{ item.courseTitle }}
                                            </span>

                                        </div>

                                    </ng-template>

                                </p-dropdown> -->

                            </div>


                            <div class="ecb-web-long-course-search-field">

                                <label for="homeLongCourseKeyword">
                                    Keyword
                                </label>

                                <div class="ecb-web-long-course-keyword">

                                    <i class="bi bi-search"></i>

                                    <input id="homeLongCourseKeyword" type="search" [(ngModel)]="searchKeyword"
                                        placeholder="Search qualifications">

                                </div>

                            </div>


                            <button type="button" class="btn ecb-web-long-course-search-button"
                                (click)="searchShortCourses()">

                                <i class="bi bi-search"></i>
                                Search

                            </button>

                        </div>

                    </div>

                </div>

            </ng-container>
            <!-- VOC Title -->

            <ng-container *ngIf="courseType === 'VOC'">

                <h1>
                    Verification of Competency
                </h1>

                <p>
                    Browse our Verification of Competency assessments.
                    Select an assessment to view detailed information,
                    required documents and enquiry options.
                </p>

            </ng-container>

            <!-- Other Title -->
            <ng-container *ngIf="courseType === 'OSC'">

                <h1>
                    Other Short Courses
                </h1>

                <p>

                </p>

            </ng-container>

            <!-- HRC Title -->
            <ng-container *ngIf="courseType === 'HRC'">

                <h1>
                    High Risk Courses
                </h1>

                <p>

                </p>

            </ng-container>

        </div>


        <!-- =====================================================
             Loading
        ====================================================== -->

        <div class="ecb-x-course-loading"
            *ngIf="  (courseType !== 'ALL' || activeAllCoursesSection === 'POPULAR') && isLoading   ">

            <div class="spinner-border" role="status">
            </div>

            <span>
                Loading courses...
            </span>

        </div>


        <!-- =====================================================
             Course Grid
        ====================================================== -->

        <div class="row g-4" *ngIf="
             (courseType !== 'ALL' || activeAllCoursesSection === 'POPULAR') &&
             !isLoading &&
             paginatedCourses.length > 0
            ">


            <div class="col-12 col-sm-6 col-lg-4 col-xl-3" *ngFor="  let course of paginatedCourses ">


                <!-- Course Card -->

                <article class="ecb-x-course-card" tabindex="0" (click)="openCourseDetails(course)"
                    (keyup.enter)="openCourseDetails(course)">


                    <!-- =================================================
                 Image
            ================================================== -->

                    <div class="ecb-x-course-image-wrapper">


                        <!-- Actual Image -->

                        <img *ngIf="hasCourseImage(course)" [src]="course.imageUrl" [alt]="getCourseTitle(course)"
                            class="ecb-x-course-image" (error)="onImageError(course)">


                        <!-- Image Fallback -->

                        <div class="ecb-x-course-image-fallback" *ngIf="!hasCourseImage(course)">

                            <div class="ecb-x-course-fallback-icon">

                                <i class="bi bi-mortarboard"></i>

                            </div>

                            <span>
                                ECB Training
                            </span>

                        </div>


                        <!-- Course Type Badge -->

                        <!--   <span class="ecb-x-course-image-badge">

                  {{ courseType }}

                </span> -->

                    </div>


                    <!-- =================================================
                 Content
            ================================================== -->

                    <div class="ecb-x-course-card-content">


                        <!-- Code -->

                        <!--  <span class="ecb-x-course-code">

                             {{ getCourseCode(course) }}

                           </span>
                -->

                        <!-- Title -->

                        <h3>

                            {{ getCourseTitle(course) }}

                        </h3>


                        <!-- Description -->

                        <div class="ecb-x-course-description ecb-x-details-rte-list"
                            [innerHTML]="getCourseDescription(course) | safeHtml">



                        </div>


                        <!-- Price -->
                        <!-- 
                        <div class="ecb-x-course-price">

                            {{ getPrice(course) }}

                        </div>
 -->

                        <!-- View Details -->

                        <button type="button" class="btn ecb-x-course-view-button"
                            (click)=" openCourseDetails(course);  $event.stopPropagation()  ">

                            <span>
                                View Course
                            </span>

                            <i class="bi bi-arrow-right"></i>

                        </button>

                    </div>

                </article>

            </div>

        </div>


        <!-- =====================================================
             No Courses
        ====================================================== -->

        <div class="ecb-x-course-empty" *ngIf="
        (courseType !== 'ALL' || activeAllCoursesSection === 'POPULAR') &&
        !isLoading &&
        courses.length === 0
      ">

            <div class="ecb-x-course-empty-icon">

                <i class="bi bi-journal-x"></i>

            </div>

            <h3>
                No Courses Available
            </h3>

            <p>
                There are currently no courses available
                in this category.
            </p>

        </div>



        <!-- =====================================================
             Other Courses Enquiry
        ====================================================== -->

        <div class="ecb-x-other-courses-panel" *ngIf="courseType === 'ALL' && activeAllCoursesSection === 'OTHER'">

            <div class="ecb-x-other-courses-heading">

                <span class="ecb-x-course-eyebrow">
                    CAN'T FIND YOUR COURSE?
                </span>

                <h1>
                    Other Courses
                </h1>

                <p>
                    Select a course from the list below and send us an enquiry.
                    If the course you need is not listed, choose <strong>Other</strong>
                    and enter the course name.
                </p>

            </div>


            <div class="ecb-x-other-course-enquiry-card">

                <div class="ecb-x-other-course-enquiry-icon">
                    <i class="bi bi-mortarboard"></i>
                </div>


                <div class="ecb-x-other-course-enquiry-content">

                    <h3>
                        Course Enquiry
                    </h3>

                    <p>
                        Tell us which course you are looking for and our team can assist you.
                    </p>


                    <div class="row g-3">

                        <div class="col-12">

                            <label for="otherCourseSelection">
                                Course
                                <span>*</span>
                            </label>

                            <select id="otherCourseSelection" class="form-select" [(ngModel)]="selectedOtherCourse"
                                name="selectedOtherCourse" (ngModelChange)="onOtherCourseSelectionChange()">

                                <option value="">
                                    Select a course
                                </option>

                                <!-- Add the supplied Other Course names to otherCourseOptions in the TS file. -->
                                <option *ngFor="let courseName of otherCourseOptions" [ngValue]="courseName">
                                    {{ courseName }}
                                </option>

                                <option value="OTHER" style="color:#e35d1a">
                                    Other
                                </option>

                            </select>

                        </div>


                        <div class="col-12 full_flex" *ngIf="selectedOtherCourse === 'OTHER'">

                            <label for="customOtherCourse">
                                Course Name
                                <span>*</span>
                            </label>

                            <input id="customOtherCourse" type="text" class="form-control" maxlength="200"
                                [(ngModel)]="customOtherCourse" name="customOtherCourse"
                                placeholder="Type the course you are looking for">

                        </div>


                        <div class="col-12 col-md-6">

                            <label for="otherEnquiryName">
                                Name
                                <span>*</span>
                            </label>

                            <input id="otherEnquiryName" type="text" class="form-control" maxlength="100"
                                [(ngModel)]="otherEnquiryName" name="otherEnquiryName" placeholder="Enter your name">

                        </div>


                        <div class="col-12 col-md-6">

                            <label for="otherEnquiryEmail">
                                Email
                                <span>*</span>
                            </label>

                            <input id="otherEnquiryEmail" type="email" class="form-control" maxlength="100"
                                [(ngModel)]="otherEnquiryEmail" name="otherEnquiryEmail"
                                placeholder="Enter your email address">

                        </div>


                        <div class="col-12">

                            <label for="otherEnquiryPhone">
                                Contact Number
                                <span>*</span>
                            </label>

                            <input id="otherEnquiryPhone" type="tel" class="form-control" appPhoneNumberValidation
                                [(ngModel)]="otherEnquiryPhone" name="otherEnquiryPhone"
                                placeholder="Enter your contact   number">

                        </div>


                        <div class="col-12">

                            <label for="otherEnquiryMessage">
                                Additional Information
                            </label>

                            <textarea id="otherEnquiryMessage" class="form-control" rows="4" maxlength="1000"
                                [(ngModel)]="otherEnquiryMessage" name="otherEnquiryMessage"
                                placeholder="Add any additional information about the training you require"></textarea>

                        </div>

                    </div>


                    <div class="alert alert-danger mt-3 mb-0" *ngIf="otherEnquiryErrorMessage">
                        {{ otherEnquiryErrorMessage }}
                    </div>


                    <div class="alert alert-success mt-3 mb-0" *ngIf="otherEnquirySuccessMessage">
                        {{ otherEnquirySuccessMessage }}
                    </div>


                    <div class="ecb-x-other-course-enquiry-actions">

                        <button type="button" class="btn ecb-x-course-view-button ecb-x-other-course-enquire-button"
                            [disabled]="isSendingOtherEnquiry" (click)="sendOtherCourseEnquiry()">

                            <span *ngIf="!isSendingOtherEnquiry">
                                Enquire
                            </span>

                            <span *ngIf="isSendingOtherEnquiry">
                                Sending...
                            </span>

                            <i class="bi bi-arrow-right" *ngIf="!isSendingOtherEnquiry"></i>

                        </button>

                    </div>

                </div>

            </div>

        </div>

        <!-- =====================================================
             Pagination
        ====================================================== -->

        <div class="ecb-x-course-pagination-wrapper" *ngIf="
             (courseType !== 'ALL' || activeAllCoursesSection === 'POPULAR') &&
             !isLoading &&
             totalPages > 1
            ">

            <ul class="ecb-x-course-pagination">


                <!-- Previous -->

                <li>

                    <button type="button" [disabled]="isLoading || currentPage === 1" (click)="previousPage()">

                        <i class="bi bi-chevron-left"></i>

                    </button>

                </li>


                <!-- Pages -->

                <li *ngFor="let page of pages">

                    <button type="button" [class.active]="
              currentPage === page
            " [disabled]="isLoading" (click)="goToPage(page)">

                        {{ page }}

                    </button>

                </li>


                <!-- Next -->

                <li>

                    <button type="button" [disabled]="
              isLoading || currentPage === totalPages
            " (click)="nextPage()">

                        <i class="bi bi-chevron-right"></i>

                    </button>

                </li>

            </ul>

        </div>

    </div>

</section>

<!-- =========================================================
     End Short Course List
========================================================= -->

<!-- =========================================================
    Start EConfirmation popup
========================================================= -->


<p-dialog [(visible)]="showEnquirySuccessPopup" [modal]="true" [closable]="false" [draggable]="false"
    [resizable]="false" [style]="{ width: '460px' }">

    <div class="text-center p-3">

        <i class="bi bi-check-circle-fill" style="
        font-size: 52px;
        color: #e35d1a;
      ">
        </i>

        <h3 style="
        margin-top: 18px;
        color: #56302b;
      ">
            Thank you for your enquiry!
        </h3>

        <p style="
        margin-top: 12px;
        color: #555;
        line-height: 1.6;
      ">

            We have received your enquiry successfully.

            <br><br>

            One of our team members will be in touch with you shortly.

        </p>

        <button type="button" class="btn ecb-x-corporate-save-button mt-3" (click)="closeEnquirySuccessPopup()">

            OK

        </button>

    </div>

</p-dialog>
<!-- =========================================================
    EndEConfirmation popup
========================================================= -->